import Diagram, { createSchema, useSchema } from "beautiful-react-diagrams";
import { getSchema, maxNodePosistion } from "Components/Device/Flow/utils";
import { useDevice } from "Hooks/Endpoints";
import useWindowSize from "Hooks/WindowSizeHook";
import { APIDeviceProps } from "Providers/types";
import React, { useEffect } from "react";

const FlowStart = () => {
  const { submitting, devices, activeFlow }: APIDeviceProps = useDevice();
  const dimensions = useWindowSize();

  const [schema, { onChange }] = useSchema(
    createSchema(getSchema(devices, activeFlow))
  );

  useEffect(() => {
    if (dimensions) {
      onChange(createSchema(getSchema(devices, activeFlow)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensions, activeFlow, devices, submitting]);

  const getMaxHeight = () => {
    return `${maxNodePosistion(schema) + 100}px`;
  };

  return (
    <div style={{ height: getMaxHeight() }}>
      {dimensions[0] > 300 && <Diagram schema={schema} onChange={onChange} />}
    </div>
  );
};

export default FlowStart;
